<template>
  <v-dialog v-model="termsDialog" persistent width=700>
    <v-card class="grey darken-4 white--text">
        <v-card-text class="pa-3">
          The Probe Miner: Objective Assessment of Chemical Probes is a community resource for the evaluation of chemical probes based on large-scale, publicly available, medicinal chemistry data. It is intended to empower researchers to select the best probes based on objective, data driven criteria. This resource provides evaluation of > 1.8m small molecules against for >2,200 human targets and is regularly updated in response to updates in the publicly available medicinal chemistry data. Our continuing data curation efforts will ensure that this resource is continually evolving and improving.
          <br/><br/>
          If you have identified any data that you believe are missing or require curation, please let us know
          [<a href="mailto:chemprobes@icr.ac.uk">chemprobes@icr.ac.uk</a>] to help us improve this resource for the community.
          Ideally, this resource should be used in conjunction with the complementary Chemical Probes Portal (<a href="http://www.chemicalprobes.org" target="_blank">ChemicalProbes.org</a>), which provides expert-driven chemical probe evaluation.
          <br/>
          <div class="pt-2">
            <small>This website uses cookies to store a small amount of information on your computer, as part of the functioning of the site. Cookies used for the operation of the site have already been set.
              To find out more about the cookies we use and how to delete them, see our <a href="http://www.icr.ac.uk/icr/cookies/index.shtml" target="_blank">Cookie</a> and <a href="http://www.icr.ac.uk/icr/privacy/index.shtml" target="_blank">
              Privacy</a> statements.
            </small>
          </div>
        </v-card-text>
        <v-card actions dark class="text-xs-right">
          <v-btn class="grey darken-4 pink--text" secondary @click.native="dialogRead">I READ IT</v-btn>
        </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Cookie from 'js-cookie'

  export default {
    props: ['termsDialog'],
    methods: {
      dialogRead() {
        Cookie.set("prbTerms", true)
        this.$store.dispatch("VERIFY_TERMS")
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PrbTerms.vue?0ceb2b24